// extracted by mini-css-extract-plugin
var _1 = "container--oB_FKWoy";
export { _1 as "container" }
